<template>
  <div
    id="HistoricalRank"
    data-test="historicalRank"
  >
    <div class="table__wrapper">
      <table
        data-test="table"
        class="table is-bordered is-striped center-table is-full-width"
      >
        <tr>
          <th
            v-for="field in fields"
            :key="field.label"
          >
            {{ field.label }}
          </th>
        </tr>
        <tr
          v-for="item in arrayOfRankings"
          :key="item.keyword"
        >
          <td
            v-for="field in fields"
            :key="field.key"
          >
            <trend-arrow
              v-if="field.key === 'change'"
              :display-figure="true"
              :num="item.change"
              data-test="change"
            />
            <span v-else>
              {{ item[field.key] || 0 }}
            </span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import TrendArrow from '@/components/Shared/TrendArrow'

export default {
  name: 'BaseHistoricalRankingReport',

  components: {
    TrendArrow
  },

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      fields: [
        {
          key: 'keyword',
          label: this.$t('seo_service.historical_rank.table.keywords')
        },
        {
          key: 'rank',
          label: this.$t('seo_service.historical_rank.table.current_rank')
        },
        {
          key: 'last',
          label: this.$t('seo_service.historical_rank.table.last_rank')
        },
        {
          key: 'initial_rank',
          label: this.$t('seo_service.historical_rank.table.init_rank')
        },
        {
          key: 'change',
          label: this.$t('seo_service.historical_rank.table.change')
        }
      ]
    }
  },

  computed: {
    arrayOfRankings () {
      return Object.keys(this.data).map((key) => ({
        ...this.data[key],
        change: this.data[key].rank - this.data[key].last,
        keyword: key
      }))
    }
  }
}
</script>
<style lang="scss" scoped>
.center-table {
  th {
    text-align: center;
    vertical-align: middle;
  }
  td {
    text-align: center;
    vertical-align: middle;
  }
}
.table__wrapper {
  overflow-x: auto;
  margin: -1.6rem;
}
  .in-line {
    display: inline-block;
  }
  .wdc-blue {
    color: rgb(34, 127, 207);
  }
  .icon-white {
    color: #ffffff;
    font-size: 12px;
  }
  .ranking-text {
    display: inline-block;
  }
  .card-body {
    padding: 5px;
  }
  .rank-card {
    padding: 10px;
  }
</style>
